export enum PaymentStatus {
    SUCCESSFUL = 'SUCCESSFUL',
    FAIL = 'FAIL',
    PAY_ON_STORE = 'PAY_ON_STORE',
    ALL = 'ALL'
}
